import PWAPrompt from "./components/PWAPromptWrapper.vue";
export default PWAPrompt;
